module.exports = __webpack_public_path__ + "img/icon-light-on.62771efd.svg";